// extracted by mini-css-extract-plugin
export default {"hideTooltip":"U--z","fadeIn":"V--z","delay":"W--z","recommendedSizeTooltip":"X--z"};